<template>
  <div class="adv_order_transporters_single" @click="onClickTransporter">
    <input name="transport_id"
           :value="getTransporters[0].transporter_id"
           type="hidden"
    >
    <SmartPoints v-if="getSmartPointsEnableForTransporter(getTransporters[0])" :transporter="getTransporters[0]" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SmartPoints from './SmartPoint/SmartPoints.vue'
import SmartPointMixin from './SmartPoint/SmartPointMixin'

export default {
  name: 'AdvOrderTransportersSingle',
  components: { SmartPoints },
  mixins: [SmartPointMixin],
  computed: {
    ...mapGetters([
      'previewOrderData',
      'getTransporters'
    ])
  },
  async mounted () {
    await this.setPreviewOrderTransporterId(this.getTransporters[0].transporter_id)
    await this.setPayWayAfterTransporterUpdate()
  },
  methods: {
    ...mapActions(['setPreviewOrderTransporterId']),
    ...mapMutations([
      'setSelectedTransporterId'
    ]),
    setPayWayAfterTransporterUpdate () {
      if (this.getIsSmartPointOnlyTransporter) {
        if (this.previewOrderData.payWay === 'delivery') {
          this.previewOrderData.payWay = this.previewOrderData.payWays.filter(payWay => payWay.key !== 'delivery')[0].key
        }
      }
    },
    onClickTransporter () {
      if (!this.getIsSmartPointOnlyTransporter) {
        return
      }
      this.setSmartPointIsSelected(true)
      this.resolveDefaultMapInitialization(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.adv_order_transporters_single {
  cursor: pointer;
}
</style>
